import React, { useState, useEffect, useRef } from 'react';
import { app , auth, firestore ,storage } from '../../firebase';
import { collection, getDocs, doc, updateDoc, deleteDoc ,getDoc} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, getMetadata  } from "firebase/storage";
import { getStorage, deleteObject } from 'firebase/storage';
import { comfortOptions ,audioOptions ,sigurantaOptions,asistentaOptions  } from "../Add post/optiuni";
import { Modal } from 'bootstrap';
import "./render.css"
import { EditModal } from '../Modal/EditModal';
import Pagination from '../Pagination/Pagination';
import Table from './Table';

async function compressImage(file, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Calculăm noile dimensiuni ale imaginii pentru compresie
        const maxWidth = 800;
        const maxHeight = 600;
        let newWidth, newHeight;

        if (image.width > image.height) {
          newWidth = maxWidth;
          newHeight = (image.height / image.width) * maxWidth;
        } else {
          newHeight = maxHeight;
          newWidth = (image.width / image.height) * maxHeight;
        }

        canvas.width = newWidth;
        canvas.height = newHeight;

        // Desenăm imaginea pe canvas cu noile dimensiuni
        ctx.drawImage(image, 0, 0, newWidth, newHeight);

        // Obținem imaginea comprimată sub formă de Blob
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, { type: 'image/jpeg' }));
        }, 'image/jpeg', quality);
      };
    };

    reader.readAsDataURL(file);
  });
}


const RenderDataComponent = ({theme}) => {

  
    const [material, setMaterial] = useState("");
    const [greutate, setgreutate] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedMainImg, setSelectedMainImg] = useState([]);
  const [pretCuTVA, setPretCuTVA] = useState(false);
   const [pret, setPret] = useState("");
   const [discount, setDiscount] = useState("");
  const [um, setum] = useState("");
  const [titlu, setTitlu] = useState("");
  const [dimensiune, setdimensiune] = useState("");
  const [comanda, setComanda] = useState(false);
   const [sku, setsku] = useState("")

  const [main, setMain] = useState([])
  const [images, setImages] = useState([])

  


  const [selectednewImg, setNewImage] = useState([]);

 





  const [currentDocId, setCurrentDocId] = useState(null); // Acesta va păstra ID-ul documentului curent pentru editare
  const [show, setShow] = useState(false);
  const [user, setUser] = useState(null);
  const [value, setValue] = useState([])

  // spining modal 
  const [showModal  ,setShowModal] = useState(false)  



  
  const handleMainImageChange = async (e) => {
    const image = e.target.files[0];
    
    if (image) {
      try {
        const compressedImage = await compressImage(image, 0.8); // Comprimăm imaginea
        setSelectedMainImg([compressedImage]); // Setăm imaginea comprimată în starea componentei
      } catch (error) {
        console.error("Eroare la comprimarea imaginii:", error);
      }
    }
  };
  // Funcție pentru gestionarea schimbărilor la imagini suplimentare
  const handleImagesChange = async (e) => {
    const images = e.target.files;
    const imagesArray = Array.from(images);
  
    // Limităm numărul de imagini la 25 (dacă utilizatorul selectează mai multe)
    const selectedImages = imagesArray.slice(0, 25);
  
    const compressedImages = [];
  
    // Comprimăm fiecare imagine și adăugăm imaginea comprimată la listă
    for (const image of selectedImages) {
      try {
        const compressedImage = await compressImage(image, 0.8); // Comprimăm imaginea cu o calitate de 0.8 (80%)
        compressedImages.push(compressedImage);
      } catch (error) {
        console.error("Eroare la comprimarea imaginilor:", error);
      }
    }
  
    // Setăm imaginile comprimate în starea componentei
    setSelectedImages(compressedImages);
  };
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  // modal Editare
  const modalRef = useRef(null);
  useEffect(() => {
    // Inițializarea modalului Bootstrap
    modalRef.current = new Modal(document.getElementById('editModal'));
  }, []);
  

  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const postCollectionRef = collection(firestore, 'post');
        const querySnapshot = await getDocs(postCollectionRef);
        const dataArray = [];
        querySnapshot.forEach((doc) => {
          const docData = doc.data();
          dataArray.push({ id: doc.id, ...docData }); // Adaugă ID-ul documentului în obiectul de date
        });

        setValue(dataArray);
      } catch (error) {
      }
    };
    fetchData();
  }, [firestore]);

  

  // Functie Editare
  const handleEdit = (values) => {
    setCurrentDocId(values.id);
    setCurrentDocId(values.id);
  
    setDiscount(values.pretNou)
 setPretCuTVA(values.pretCuTVA)

 setComanda(values.comanda)

   setTitlu(values.titlu)
   setMaterial(values.material)
   setgreutate(values.greutate)
   setum(values.um)
   setdimensiune(values.dimensiune)
   setsku(values.sku)
    setMain(values.mainImage)
    setImages(values.images)
    setShow(true);
    modalRef.current.show();
  };
  
  
  const handleUpdate = async () => {
    try {
      setShowModal(true);
  
      if (!currentDocId) return;
  
      const updateData = doc(firestore, "post", currentDocId);
      const postDocData = await getDoc(updateData);
      const postDoc = postDocData.data();
  
      if (!postDoc) {
        console.error("Document not found");
        return;
      }
  
      const updatedFields = {};
  
      // ✅ Actualizare imagine principală
      if (selectedMainImg && selectedMainImg.length === 1) {
        const mainImage = selectedMainImg[0];
        const uniqueName = `${Date.now()}_${mainImage.name}`;
        const storageRef = ref(storage, `mainImages/${uniqueName}`);
  
        // Ștergere imagine veche dacă există
        if (postDoc.mainImage) {
          const currentMainImageName = Object.keys(postDoc.mainImage)[0];
          if (currentMainImageName) {
            const oldMainImageRef = ref(storage, "mainImages/" + currentMainImageName);
            try {
              await getMetadata(oldMainImageRef);
              await deleteObject(oldMainImageRef);
            } catch (error) {
              if (error.code !== "storage/object-not-found") throw error;
            }
          }
        }
  
        // Încărcare imagine nouă
        const snapshot = await uploadBytes(storageRef, mainImage);
        const downloadURL = await getDownloadURL(snapshot.ref);
        updatedFields.mainImage = { [uniqueName]: downloadURL };
      }
  
      // ✅ Actualizare imagini secundare
      if (selectedImages && selectedImages.length > 0) {
        const imagesObject = {};
  
        // Ștergere imagini vechi
        if (postDoc.images) {
          await Promise.all(
            Object.keys(postDoc.images).map(async (imageName) => {
              const oldImageRef = ref(storage, "images/" + imageName);
              try {
                await getMetadata(oldImageRef);
                await deleteObject(oldImageRef);
              } catch (error) {
                if (error.code !== "storage/object-not-found") throw error;
              }
            })
          );
        }
  
        // Încărcare imagini noi
        await Promise.all(
          selectedImages.map(async (image) => {
            const uniqueName = `${Date.now()}_${image.name}`;
            const storageRef = ref(storage, `images/${uniqueName}`);
            const snapshot = await uploadBytes(storageRef, image);
            const downloadURL = await getDownloadURL(snapshot.ref);
            imagesObject[uniqueName] = downloadURL;
          })
        );
  
        updatedFields.images = imagesObject;
      }
  
      // ✅ Actualizare date produs
      Object.assign(updatedFields, {
        titlu,
        sku,
        um,
        material,
        greutate,
        comanda,
        dimensiune,
        pret,
        pretCuTVA,
        pretNou: discount,
      });
  
      await updateDoc(updateData, updatedFields);
  
      // ✅ Actualizare state local
      setValue((prev) =>
        prev.map((item) =>
          item.id === currentDocId ? { id: currentDocId, ...updatedFields } : item
        )
      );
  
      // ✅ Resetare și închidere modal
      resetForm();
      setShow(false);
      setCurrentDocId(null);
      alert("Produsul s-a actualizat cu succes!");
  
      if (modalRef.current && typeof modalRef.current.hide === "function") {
        modalRef.current.hide();
      }
  
      // ❗ Evită reload dacă nu e necesar
      window.location.reload();
  
    } catch (error) {
      console.error("Eroare la actualizare:", error);
      alert(`Eroare la actualizare: ${error.message}`);
    } finally {
      setShowModal(false);
    }
  };
  
  
  const resetForm = () => {
    setgreutate("");
   
    
    setPret("");
    setsku("");
    setDiscount("");
    setum("");
    setdimensiune("");
    setMaterial("");
    
    setComanda(false);
   
    setTitlu("");
    setSelectedMainImg([]);
    setSelectedImages([]);
  };
  




 
  const handleDelete = async (id) => {
    try {
      setShowModal(true)
      if (id) {
        const deleteVal = doc(firestore, 'post', id);
        const documentSnapshot = await getDoc(deleteVal);
        const data = documentSnapshot.data();
    
        if (data) {
          // Șterge imaginile din Storage dacă există
          if (data.images) {
            for (const imageName in data.images) {
              // Construiți calea pentru imagine
              const imageRefPath = "images/" + imageName;
              const imageRef = ref(storage, imageRefPath);
              await deleteObject(imageRef);
            }
          }
    
         // Șterge mainImage din Storage
         if (data.mainImage) {
          for( const mainName in data.mainImage) {

            const mainImageRefPath = "mainImages/" + mainName;
            const mainImageRef = ref(storage, mainImageRefPath);
            await deleteObject(mainImageRef);
          }
        }
    
          // Șterge documentul din Firestore
          await deleteDoc(deleteVal);
    
         alert('Produsul a fost șters cu succes.');
      
          window.location.reload();
    
          // Poți actualiza local lista de date eliminând elementul cu id-ul specificat
          setValue((prevValue) => prevValue.filter((item) => item.id !== id));
        } else {
          console.log('Documentul nu a fost găsit.');
        }
      }
    } catch (error) {
      console.error('Eroare la ștergere:', error);
    }
    setShowModal(false)
  };


  
  // Funcția pentru ștergerea imaginilor
const deleteSelectedImage = async (imageName) => {
  try {
    // Verifică dacă imaginea există în Firestore și o șterge
    const postDocData = await getDoc(doc(firestore, 'post', currentDocId));
    const postDoc = postDocData.data();

    if (postDoc && postDoc.images && postDoc.images[imageName]) {
      // Șterge imaginea din Firestore
      delete postDoc.images[imageName];
      const postDocRef = doc(firestore, "post", currentDocId);
      await updateDoc(postDocRef, {
        images: postDoc.images,
      });

      // Șterge imaginea din stocare
      const imageRef = ref(storage, "images/" + imageName);
      await deleteObject(imageRef);

      console.log("Imaginea a fost ștearsă cu succes.");
     setImages(postDoc.images)
    } else {
      console.log("Imaginea nu a fost găsită.");
    }
  } catch (error) {
    console.error('Eroare la ștergere imagine:', error);
  }
};


// Funcția pentru ștergerea imaginii principale
const deleteSelectedMainImage = async (imageName) => {
  try {
    // Verifică dacă imaginea există în Firestore
    const postDocRef = doc(firestore, 'post', currentDocId);
    const postDocData = await getDoc(postDocRef);
    const postDoc = postDocData.data();

    console.log("Document Firestore:", postDoc); // Debugging

    if (postDoc) {
      // Verifică dacă imaginea este prezentă în obiectul mainImage
      if (postDoc.mainImage && postDoc.mainImage[imageName]) {
        console.log("Imagine găsită în Firestore:", imageName);

        // Șterge imaginea din Firestore
        const updatedMainImage = { ...postDoc.mainImage };
        delete updatedMainImage[imageName];

        await updateDoc(postDocRef, {
          mainImage: updatedMainImage,
        });

        // Șterge imaginea din stocare
        const imageRef = ref(storage, "mainImages/" + imageName);
        await deleteObject(imageRef);

        console.log("Imaginea a fost ștearsă cu succes.");
      } else {
        console.log("Imaginea nu a fost găsită în obiectul mainImage.");
      }
    } else {
      console.log("Documentul din Firestore nu a fost găsit.");
    }
  } catch (error) {
    console.error('Eroare la ștergere imagine:', error);
  }
};





const handleFileChange = (e) => {
  const file = e.target.files[0]; // Accesează primul fișier din lista de fișiere

  if (file) {
    setNewImage(file);
  }
};



const handleImageChange = async (key) => {
  try {
    if (currentDocId && selectednewImg) {
      // Șterge imaginea veche din Firestore și stocare
      const postDocData = await getDoc(doc(firestore, 'post', currentDocId));
      const postDoc = postDocData.data();

      if (postDoc && postDoc.images && postDoc.images[key]) {
        const oldImageName = key;
        const oldImageRef = ref(storage, "images/" + oldImageName);
        await deleteObject(oldImageRef);
      }

      // Încarcă și actualizează noua imagine
      const storageRef = ref(storage, "images/" + selectednewImg.name);
      const snapshot = await uploadBytes(storageRef, selectednewImg);
      const downloadURL = await getDownloadURL(snapshot.ref);

      const imagesObject = {
        ...postDoc.images,
        [key]: downloadURL
      };

      const postDocRef = doc(firestore, "post", currentDocId);
      await updateDoc(postDocRef, {
        images: imagesObject,
      });

      console.log("Imaginea a fost schimbată cu succes.");
      alert("Imaginea a fost schimbată cu succes.")
      //aici trebuie actualizare
    }
  } catch (error) {
    console.error('Eroare la schimbarea imaginii:', error);
  }
};



// Apelul funcției handleImageChange atunci când dorești să schimbi imaginea
// Poți furniza noua imagine ca argument pentru funcție
// handleImageChange(newImage);

  
 


  //Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8; // Numărul de articole pe pagină
  // Calculați indexul de start și sfârșit pentru rândurile curente
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // Obțineți rândurile pentru pagina curentă
  const currentRows = value.slice(startIndex, endIndex);
  const totalPages = Math.ceil(value.length / itemsPerPage);
  // Funcție pentru a schimba pagina
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  


  return (
    <div className={`render-component ${theme === "dark" ? "dark-theme" : ""}`}>
      <h5 className='mx-3 my-3'>Listă produse online</h5>

    <Table currentRows={currentRows} showModal={showModal} setShowModal={setShowModal} handleEdit={handleEdit} handleDelete={handleDelete} theme={theme}/>

    {/* Paginarea */}
    <Pagination  currentPage={currentPage} handlePageChange={handlePageChange} totalPages={totalPages} theme={theme} />

      {/* Modal */}
      <EditModal 
      
       pret={pret}
       setPret={setPret}
pretCuTVA={pretCuTVA}
setPretCuTVA={setPretCuTVA}
setDiscount={setDiscount}
discount={discount}
comanda={comanda}
setComanda={setComanda}
titlu={titlu}
setTitlu={setTitlu}
      material={material}
      setmaterial={setMaterial}
      sku={sku}
      setsku={setsku}
      greutate={greutate}
      setgreutate={setgreutate}
      um={um}
      setum={setum}
      dimensiune={dimensiune}
      setdimensiune={setdimensiune}
  handleMainImageChange={handleMainImageChange}
  main={main}
  handleImagesChange={handleImagesChange}
  images={images}
  handleUpdate={handleUpdate}
  theme={theme}
  deleteSelectedImage={deleteSelectedImage}
  deleteSelectedMainImage={deleteSelectedMainImage}
  handleImageChange={handleImageChange}
  handleFileChange={handleFileChange}
  selectednewImg ={selectednewImg }
  setNewImage={setNewImage}
  showModal={showModal} 
  setShowModal={setShowModal} 
/>

    </div>

  );
};

export default RenderDataComponent;
